<template>
  <v-row align="center" justify="center">
    <v-col md="6">
      <v-card :loading="loading" :disabled="loading">
        <v-card-title>
          Update Lottery
        </v-card-title>
        <v-card-text>
          <validation-observer ref="validationObserver" slim>
            <lottery-form ref="form" v-model="lottery" :params="params" @submit="updateLottery">
            </lottery-form>
          </validation-observer>
          <v-card-actions>
            <v-btn
              color="primary"
              @click="$router.push($routes.admin.lottery.indexRoute)"
            >
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="updateLottery">
              Update
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import LotteryForm from "../../../components/lottery/LotteryForm";
import LotteryCreateUpdate from "./LotteryCreateUpdate";
import { fetchLottery, updateLottery } from "../../../../api/lottery.api";

export default {
  name: "LotteryUpdate",
  components: { LotteryForm },
  extends: LotteryCreateUpdate,
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  watch: {
    $route() {
      this.$startLoading();
      this.fetchLottery(this.id);
      this.$finishedLoading();
    }
  },
  async mounted() {
    this.$startLoading();
    await this.fetchLottery(this.id);
    this.$finishedLoading();
  },
  methods: {
    updateLottery() {
      const { lottery, $routes, $router, $refs } = this,
        lotteryToSend = {
          ...lottery,
          logo:
            this.lottery.logo && this.lottery.logo.normal ? null : lottery.logo
        };

      updateLottery(this.id, lotteryToSend)
        .then(() => {
          $router.push({
            name: $routes.admin.lottery.indexRoute.name
          });
        })
        .catch(error =>
          this.handleErrorResponse($refs.validationObserver, error)
        );
    },
    async fetchLottery(lotteryId) {
      try {
        const { data } = await fetchLottery(lotteryId),
          { lottery } = data;

        this.lottery = lottery;
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style scoped></style>
